export default __webpack_public_path__ + "static/media/filter_icon_spa_blue.5de6207e.svg";